import { usePlayground } from "@/components/Playground2/playground-store";
import { TemplateFormat } from "@/components/Playground2/types";

const useEditorMode = (): TemplateFormat => {
  try {
    const playground = usePlayground();

    return playground.template_format;
  } catch (e) {
    return "f-string";
  }
};

export default useEditorMode;
